import { PrinterPosRemoveIcon } from './PrinterPosRemoveIcon';

/**
 * author: Colton Wiscombe
 * id 21A677FB-E227-4D63-A4FE-08FE9A1D7065
 * name printer-pos-remove
 * version: 7.1.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/printer-pos-remove.svg
 * tags
 * - Printer 
 */
export const PrinterPointOfSaleRemoveIcon = PrinterPosRemoveIcon;
export default PrinterPointOfSaleRemoveIcon